<template>
  <div class="oo-viewer">
    <div v-if="loading" class="oo-loading">正在加载 OnlyOffice 预览...</div>
    <div v-else-if="error" class="oo-error">{{ error }}</div>
    <div :id="editorId" class="oo-editor"></div>
  </div>
</template>

<script>
import { loadOnlyOfficeApi, buildViewConfig } from '@/utils/onlyoffice'

let editorSeq = 0

export default {
  name: 'OnlyOfficeViewer',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data() {
    editorSeq += 1
    return {
      editorId: `oo-editor-${editorSeq}`,
      editor: null,
      loading: false,
      error: ''
    }
  },
  watch: {
    config: {
      immediate: true,
      handler(val) {
        if (val && val.document && val.document.url) {
          this.mountEditor(val)
        }
      }
    }
  },
  beforeDestroy() {
    this.destroyEditor()
  },
  methods: {
    destroyEditor() {
      if (this.editor) {
        try {
          this.editor.destroyEditor()
        } catch (e) { /* ignore */ }
        this.editor = null
      }
    },
    async mountEditor(rawConfig) {
      this.loading = true
      this.error = ''
      this.destroyEditor()
      try {
        const DocsAPI = await loadOnlyOfficeApi(rawConfig.documentServerUrl)
        const cfg = buildViewConfig(rawConfig)
        await this.$nextTick()
        this.editor = new DocsAPI.DocEditor(this.editorId, cfg)
      } catch (e) {
        this.error = (e && e.message) || 'OnlyOffice 初始化失败'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.oo-viewer {
  width: 100%;
  height: calc(100vh - 110px);
  min-height: 520px;
  position: relative;
  background: #f5f5f5;
}
.oo-editor {
  width: 100%;
  height: 100%;
}
.oo-loading,
.oo-error {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  z-index: 2;
  background: #f5f5f5;
}
.oo-error {
  color: #f56c6c;
  padding: 24px;
  text-align: center;
}
</style>
